import { useContext, useEffect, useRef } from "react";
import { useListContext } from "react-admin";
import { GridUserDataContext } from "contexts/GridUserDataProvider";
import { getValidationErrors } from "api/getValidationErrors";

const getInvalidFilterFields = (errors) => {
	const filterError = errors.find((e) => e.code === "INVALID_FILTER_FIELDS");
	if (!filterError) return [];
	return filterError.fields || [];
};

const hasInvalidSort = (errors) => {
	return errors.some((e) => e.code === "INVALID_SORT_FIELD");
};

const DEFAULT_SORT = { field: "id", order: "DESC" };

export const useResetUserDataOnError = () => {
	const { error, filterValues, setFilters, setSort } = useListContext();
	const context = useContext(GridUserDataContext);
	const handledErrorRef = useRef(null);

	useEffect(() => {
		if (!error || error === handledErrorRef.current) return;
		handledErrorRef.current = error;

		const errors = getValidationErrors(error);
		const invalidFilters = getInvalidFilterFields(errors);
		const invalidSort = hasInvalidSort(errors);

		if (invalidFilters.length > 0) {
			const cleanedFilters = { ...filterValues };
			invalidFilters.forEach((field) => delete cleanedFilters[field]);
			setFilters(cleanedFilters, []);
		}

		if (invalidSort) {
			const defaultSort = context?.getSortDefaultValues?.() || DEFAULT_SORT;
			setSort(defaultSort.field, defaultSort.order);
		}
	}, [error, filterValues, setFilters, setSort, context]);
};
